import { documentConstants } from "../../constants";

const defaultState = {
    items: [],
    item: {},
    loadingItems: false,
    loadingItem: false,
    fetchedItems: false,
    fetchedItem: false,
    error: null
};

function normalData(arr) {
    if (!Array.isArray(arr)) return [];
    return arr.map((elem, index) => ({
        ...elem,
        index: (index + 1),
        whoCreated: typeof elem.whoCreated === 'object' ? elem.whoCreated.fullName : elem.whoCreated,
        whoUpdated: typeof elem.whoUpdated === 'object' && elem.whoUpdated ? elem.whoUpdated.fullName : elem.whoUpdated,
        // Преобразуем даты для отображения
        paymentDate: elem.paymentDate ? new Date(elem.paymentDate) : null,
        dateCreate: elem.dateCreate ? new Date(elem.dateCreate) : null,
        dateDocument: elem.dateDocument ? new Date(elem.dateDocument) : null,
        lastUpdated: elem.lastUpdated ? new Date(elem.lastUpdated) : null,
        dateDelete: elem.dateDelete ? new Date(elem.dateDelete) : null,
        dateArchive: elem.dateArchive ? new Date(elem.dateArchive) : null,
    }));
}

export const paymentReducer = function (state = defaultState, action) {
    switch (action.type) {
        // GET ALL
        case documentConstants.GETALL_REQUEST_PAYMENT:
            return {
                ...state,
                loadingItems: true,
                fetchedItems: false,
                error: null
            };
        case documentConstants.GETALL_SUCCESS_PAYMENT:
            return {
                ...state,
                items: normalData(action.response),
                loadingItems: false,
                fetchedItems: true,
            };
        case documentConstants.GETALL_FAILURE_PAYMENT:
            return {
                ...state,
                loadingItems: false,
                fetchedItems: false,
                error: action.error,
            };

        // UPDATE
        case documentConstants.UPDATE_REQUEST_PAYMENT:
            return {
                ...state,
                loadingItem: true,
                fetchedItem: false,
                error: null
            };
        case documentConstants.UPDATE_SUCCESS_PAYMENT:
            return {
                ...state,
                loadingItem: false,
                fetchedItem: true,
                item: action.response,
                items: normalData(state.items.map((elem) => {
                    if (elem.id === action.response.id) {
                        return {
                            ...elem,
                            ...action.response,
                            operationTypeId: action.response.operationTypeId ?? elem.operationTypeId, // <-- Обновляем числовой ID
                            paymentDate: action.response.paymentDate ? new Date(action.response.paymentDate) : elem.paymentDate,
                            lastUpdated: action.response.lastUpdated ? new Date(action.response.lastUpdated) : elem.lastUpdated,
                            whoUpdated: typeof action.response.whoUpdated === 'object' && action.response.whoUpdated
                                ? action.response.whoUpdated.firstName + " " + action.response.whoUpdated.lastName
                                : action.response.whoUpdated || elem.whoUpdated,
                        };
                    }
                    return elem;
                }))
            };
        case documentConstants.UPDATE_FAILURE_PAYMENT:
            return {
                ...state,
                loadingItem: false,
                fetchedItem: false,
                error: action.error,
            };

        // ARCHIVE
        case documentConstants.ARCHIVE_REQUEST_PAYMENT:
            return {
                ...state,
                loadingItem: true,
                fetchedItem: false,
                error: null,
            };
        case documentConstants.ARCHIVE_SUCCESS_PAYMENT:
            return {
                ...state,
                loadingItem: false,
                fetchedItem: false,
                items: normalData(state.items.map((elem) => {
                    if (elem.id === action.id) {
                        return {
                            ...elem,
                            isArchive: !elem.isArchive,
                            dateArchive: !elem.isArchive ? new Date() : null,
                            whoArchived: !elem.isArchive ? state.whoUpdated : null,
                        };
                    }
                    return elem;
                }))
            };
        case documentConstants.ARCHIVE_FAILURE_PAYMENT:
            return {
                ...state,
                loadingItem: false,
                error: action.error,
            };

        // DELETE
        case documentConstants.DELETE_REQUEST_PAYMENT:
            return {
                ...state,
                loadingItem: true,
                fetchedItem: false,
                error: null,
            };
        case documentConstants.DELETE_SUCCESS_PAYMENT:
            return {
                ...state,
                loadingItem: false,
                fetchedItem: false,
                items: normalData(state.items.map((elem) => {
                    if (elem.id === action.id) {
                        return {
                            ...elem,
                            isDeleted: true,
                            dateDelete: new Date(),
                            whoDeleted: state.whoUpdated,
                        };
                    }
                    return elem;
                }))
            };
        case documentConstants.DELETE_FAILURE_PAYMENT:
            return {
                ...state,
                loadingItem: false,
                error: action.error,
            };

        // VIEW STATUS
        case documentConstants.VIEW_REQUEST_PAYMENT:
            return {
                ...state,
                loadingItem: true,
                fetchedItem: false,
                error: null,
            };
        case documentConstants.VIEW_SUCCESS_PAYMENT:
            return {
                ...state,
                loadingItem: false,
                fetchedItem: true,
                item: {
                    ...state.item,
                    viewStatus: action.response?.viewStatus
                },
                items: normalData(
                    state.items.map((elem) =>
                        elem.id === action.response?.documentId
                            ? { ...elem, viewStatus: action.response?.viewStatus }
                            : elem
                    )
                ),
            };
        case documentConstants.VIEW_FAILURE_PAYMENT:
            return {
                ...state,
                loadingItem: false,
                error: action.error,
            };

        // RESET
        case "RESET_ITEM_PAYMENT":
            return {
                ...state,
                fetchedItem: false,
                loadingItem: false,
                item: {}
            };

        case "RESET_ITEMS_PAYMENT":
            return {
                ...state,
                fetchedItems: false,
                loadingItems: false,
                items: [],
                error: null
            };

        default:
            return state;
    }
};